export default __webpack_public_path__ + "static/heading-image-4a4de885d22975a08466099afb222142.svg";